import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useMutation, useQuery } from '@tanstack/react-query';
import { emailChangesApi } from 'api';
import { useAuth } from 'contexts/authContext';
import { PageLoading } from 'components/PageLoading';
import { useGlobal } from '../../contexts/globalContext';
import { Button } from '../_new/Button';

const EmailChangeConfirm = () => {
	const { t } = useTranslation();
	const { logout } = useAuth();

	const { token } = useParams();
	const { toastRef } = useGlobal();
	const {
		mutate,
		isSuccess,
		isError: confirmationError,
		isLoading: confirmationLoading,
	} = useMutation(['confirmEmailChange'], emailChangesApi.confirmEmailChange, {
		onSuccess: () => {
			toastRef?.current?.show({
				severity: 'success',
				detail: t('auth.emailChangeSuccess'),
			});
			setTimeout(() => {
				logout();
			}, 15000);
		},
		onError: () => {},
	});

	const { isLoading: validatingLoading, isError: validatingError } = useQuery<boolean>(
		['validateEmailChange'],
		() => emailChangesApi.validateEmailChange({ token: String(token) }),
		{
			enabled: true,
			refetchOnWindowFocus: false,
			onSuccess: () => {
				if (token) {
					mutate({ token });
				}
			},
		}
	);

	if (validatingLoading || confirmationLoading) {
		return <PageLoading />;
	}
	if (validatingError || confirmationError) {
		return (
			<div className="flex flex-column items-center justify-center row-gap-4">
				<div>{t('auth.emailChangeError')}</div>
				<Button
					className="button-rounded button-size-md"
					label={t('auth.backToLogin')}
					onClick={() => logout()}
				/>
			</div>
		);
	}
	if (isSuccess) {
		return (
			<div className="flex flex-column items-center justify-center row-gap-4">
				<div>{t('auth.emailChangeSuccess')}</div>
				<Button
					className="button-rounded button-size-md"
					label={t('auth.backToLogin')}
					onClick={() => logout()}
				/>
			</div>
		);
	}

	return <Helmet title={t('auth.emailChangeTitle')} />;
};

export default EmailChangeConfirm;
